(function () {
    'use strict';

    angular
        .module("skillsApp")
        .filter('lowerCaseFirstLetter', function () {
            return function (input) {
                if (angular.isString(input)) {
                    return input.charAt(0).toLowerCase() + input.slice(1);
                }
                return input;
        };
    });
})();